module.exports = __webpack_public_path__ + "img/combo.efff6d51.png";